import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import 'react';
import { DefaultItem } from './DefaultItem.js';
import defaultStyles from './styles/Pagination.module.scss.js';
import { usePagination } from './utils/usePagination.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Pagination = ({
  theme,
  itemComponent,
  page,
  initialPage = 1,
  total,
  siblings = 1,
  boundaries,
  onChange,
  getItemAriaLabel,
  withEdges = false,
  withControls = true,
  showDots = true,
  disabled
}) => {
  const {
    range,
    setPage,
    next,
    previous,
    active,
    first,
    last
  } = usePagination({
    page,
    siblings,
    total,
    onChange,
    initialPage,
    boundaries,
    showDots
  });
  const Item = itemComponent || DefaultItem;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const items = range.map((pageNumber, index) => /*#__PURE__*/jsx(Item, {
    className: clsx(styles.item, pageNumber === active && styles.active),
    page: pageNumber,
    active: pageNumber === active,
    "aria-current": pageNumber === active ? 'page' : undefined,
    "aria-label": typeof getItemAriaLabel === 'function' ? getItemAriaLabel(pageNumber) : null,
    tabIndex: pageNumber === 'dots' ? -1 : 0,
    "data-dots": pageNumber === 'dots' || undefined,
    "data-active": pageNumber === active || undefined,
    onClick: pageNumber !== 'dots' ? () => setPage(pageNumber) : undefined,
    disabled: disabled
  }, index));
  return /*#__PURE__*/jsxs("div", {
    className: styles.root,
    role: "navigation",
    children: [withEdges && /*#__PURE__*/jsx(Item, {
      className: clsx(styles.item, styles.arrow),
      page: "first",
      onClick: first,
      "aria-label": getItemAriaLabel ? getItemAriaLabel('first') : undefined,
      "aria-disabled": active === 1 || disabled,
      disabled: active === 1 || disabled
    }), withControls && /*#__PURE__*/jsx(Item, {
      className: clsx(styles.item, styles.arrow),
      page: "prev",
      onClick: previous,
      "aria-label": getItemAriaLabel ? getItemAriaLabel('prev') : undefined,
      "aria-disabled": active === 1 || disabled,
      disabled: active === 1 || disabled
    }), items, withControls && /*#__PURE__*/jsx(Item, {
      className: clsx(styles.item, styles.arrow),
      page: "next",
      onClick: next,
      "aria-label": getItemAriaLabel ? getItemAriaLabel('next') : undefined,
      "aria-disabled": active === total || disabled,
      disabled: active === total || disabled
    }), withEdges && /*#__PURE__*/jsx(Item, {
      className: clsx(styles.item, styles.arrow),
      page: "last",
      onClick: last,
      "aria-label": getItemAriaLabel ? getItemAriaLabel('last') : undefined,
      "aria-disabled": active === total || disabled,
      disabled: active === total || disabled
    })]
  });
};

export { Pagination };
